import palette from '@/theme/themePalette';
import { IconButton, IconButtonProps } from '@mui/material';
import React from 'react';

type TooltipIconProps = IconButtonProps & {
  href?: string;
  component?: React.ElementType;
};

export const TooltipIcon = React.forwardRef(function MyComponent(
  props: TooltipIconProps,
  ref: React.Ref<HTMLButtonElement>,
) {
  return (
    <IconButton
      ref={ref}
      {...props}
      component={props.component || 'span'}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        '&:hover': {
          backgroundColor: palette.grey[800],
        },
        '& svg': {
          color: palette.primary.main,
        },
        ...(props?.sx || {}),
      }}
    >
      {props.children}
    </IconButton>
  );
});
